import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03a35999"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "wrap_left" }
const _hoisted_3 = { class: "wrap_black black_one" }
const _hoisted_4 = { class: "mod_c_title" }
const _hoisted_5 = { class: "left_one_wrap" }
const _hoisted_6 = { class: "left_one_wrap_item" }
const _hoisted_7 = { class: "left_one_wrap_item_right" }
const _hoisted_8 = { class: "wrap_black black_twe" }
const _hoisted_9 = { class: "mod_c_title" }
const _hoisted_10 = { class: "mod_c_tbody wrap_body" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "wrap_black black_three" }
const _hoisted_13 = { class: "mod_c_title" }
const _hoisted_14 = { class: "wrap_body" }
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "map_list" }
const _hoisted_17 = { class: "tobody_box" }
const _hoisted_18 = {
  key: 0,
  class: "tobody_main"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "wrap_empty_wrap"
}
const _hoisted_21 = { class: "wrap_right" }
const _hoisted_22 = { class: "wrap_black black_four" }
const _hoisted_23 = { class: "mod_c_title" }
const _hoisted_24 = { class: "mod_c_tbody wrap_body" }
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "black_five" }
const _hoisted_27 = { class: "wrap_black black_six" }
const _hoisted_28 = { class: "mod_c_title" }
const _hoisted_29 = { class: "mod_c_tbody wrap_body" }
const _hoisted_30 = ["id"]
const _hoisted_31 = {
  key: 0,
  class: "wrap_body_con_text"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "总访问", -1))
const _hoisted_33 = { style: {"font-size":"19px","font-weight":"500"} }
const _hoisted_34 = { class: "wrap_black black_six" }
const _hoisted_35 = { class: "mod_c_title" }
const _hoisted_36 = { class: "mod_c_tbody wrap_body" }
const _hoisted_37 = ["id"]
const _hoisted_38 = { class: "wrap_black black_three" }
const _hoisted_39 = { class: "mod_c_title" }
const _hoisted_40 = { class: "wrap_body flowing_water" }
const _hoisted_41 = { class: "wrap_body_con" }
const _hoisted_42 = ["src"]

import Crumb from '@/components/Crumb.vue';
import { useRoute } from 'vue-router';
import { reactive, ref, onMounted, getCurrentInstance } from 'vue';
import { UploadOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons-vue';
import { message, notification, Table } from 'ant-design-vue';
import {
  Overview,
  StatisticsData,
  RegionRankDataClass,
  Column,
  MapSource,
  WaterSource,
  AccessSourceClass,
  AccessSource,
  EquipmentClass,
  Equipment,
  MapSourceClass,
  WatchRankData,
} from './type';
import * as echarts from 'echarts';
import http from '@/api';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { emptyDataSec, emptyEcharts } from '@/assets';
import { getToken } from '@/plugins/cookie';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChapterPlayback',
  setup(__props) {

const aTable = Table;
const route = useRoute();
const studioId = route.params.studioId;
// 观看总览
const dataOverview = reactive<Overview[]>([
  {
    key: 0,
    info: '视频浏览量',
    icon: 'chapter_browse',
    num: 0,
    background: '#EFEFFF',
  },
  {
    key: 1,
    info: '观看平均时长',
    icon: 'chapter_average',
    num: 0,
    background: '#E1FFF9',
  },
  {
    key: 2,
    info: '观看总时长',
    icon: 'chapter_total_average',
    num: 0,
    background: '#FFF5E4',
  },
]);

const getViewOverview = () => {
  http.dotCensus
    .getViewOverview({ params: { studio_id: studioId } })
    .then((res) => {
      dataOverview[0].num = res.data.data.views || 0; //视频浏览量
      dataOverview[1].num = res.data.data.average_duration || 0; //观看平均时长
      dataOverview[2].num = res.data.data.total_duration || 0; //观看总时长
    })
    .catch((err) => console.error(err.data.error));
};
getViewOverview();

const getRandomColor = (colorKey: string, index: number) => {
  const colors = {
    accessSource: ['#0CCEB4', '#5B8FF9', '#65789B', '#F6BD16'],
    watchRank: ['#FF7777', '#FFC460', '#9378FF', '#5B8FF9', '#00CCB0', '#E2E7EC'],
    Statistics: ['#00CCB0', '#9378FF', '#5B8FF9', '#65789B', '#E2E7EC', '#FF7777', '#FF7777'],
  };
  const newColorArr = colors[colorKey];
  return index > newColorArr.length - 1 ? newColorArr[newColorArr.length - 1] : newColorArr[index];
};

// 观看统计
const statisticsCharsDatas = reactive<StatisticsData>({ time_list: [], view_list: [] });

const statistics = ref(`statistics${Date.now() + Math.random()}`);

let statisticsChars: echarts.ECharts;

const optionsStatistics = (sourceData: StatisticsData) => {
  if (sourceData.time_list.length === 0) {
    const option = {
      title: {
        text: '{a| }',
        x: 'center',
        y: 'center',
        textStyle: {
          rich: {
            a: {
              color: '#000',
              fontSize: '16',
              height: 160,
              width: 172,
              backgroundColor: {
                image: emptyEcharts,
              },
            },
          },
        },
      },
    };
    return option;
  } else {
    const option = {
      legend: {
        left: '6%',
      },
      grid: {
        left: '9%',
        right: '5%',
        bottom: '10%',
      },
      xAxis: {
        type: 'category',
        data: sourceData.time_list,
        axisLabel: {
          formatter(params: string) {
            if (params.length > 4) {
              return params.substring(0, 4) + '...';
            } else {
              return params;
            }
          },
        },
      },
      yAxis: {
        type: 'value',
        splitLine: {
          lineStyle: {
            type: 'dashed',
          },
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      series: sourceData.view_list,
      // series: [
      //   {
      //     name: '观看量',
      //     data: sourceData.views,
      //     type: 'line',
      //     symbolSize: 6,
      //     symbol: 'circle',
      //     smooth: true,
      //     lineStyle: {
      //       width: 3,
      //       color: '#00CCB0',
      //     },
      //     itemStyle: {
      //       borderWidth: 2,
      //       borderColor: 'white',
      //       color: '#00CCB0',
      //     },
      //   },
      // ],
    };
    return option;
  }
};

const statisticsCharsOption = (sourceData: StatisticsData) => {
  statisticsChars.setOption(optionsStatistics(sourceData));
};

const getViewStatistics = () => {
  http.dotCensus.getViewStatistics({ params: { studio_id: studioId } }).then((res) => {
    statisticsCharsDatas.time_list = res.data.data.time_list || [];
    const resData = res.data.data.view_list;
    resData.forEach((e: any, index: number) => {
      e.name = e.node_title;
      e.type = 'line';
      e.itemStyle = { borderWidth: 2, borderColor: 'white', color: getRandomColor('Statistics', index) };
      e.symbolSize = 6;
      e.symbol = 'circle';
      e.smooth = true;
      e.lineStyle = { width: 3, color: getRandomColor('Statistics', index) };
      e.data = e.views;
    });

    statisticsCharsDatas.view_list = resData || [];

    // 观看统计
    const statisticsDom: HTMLElement = document.getElementById(statistics.value) as HTMLElement;
    statisticsChars = echarts.init(statisticsDom);
    statisticsCharsOption(statisticsCharsDatas);
  });
};
getViewStatistics();

// 观看排名
const watchRank = ref(`watchRank${Date.now() + Math.random()}`);

const watchRankCharsDatas = reactive<WatchRankData>({ node_title: [], views: [] });

let watchRankChars: echarts.ECharts;

const optionsWatchRank = (sourceData: WatchRankData) => {
  if (sourceData.node_title.length === 0) {
    const option = {
      title: {
        text: '{a| }',
        x: 'center',
        y: 'center',
        textStyle: {
          rich: {
            a: {
              color: '#000',
              fontSize: '16',
              height: 160,
              width: 172,
              backgroundColor: {
                image: emptyEcharts,
              },
            },
          },
        },
      },
    };
    return option;
  } else {
    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true,
      },
      xAxis: {
        type: 'value',
      },
      yAxis: {
        type: 'category',
        data: sourceData.node_title,
        axisLabel: {
          formatter(params: string) {
            if (params.length > 4) {
              return params.substring(0, 4) + '...';
            } else {
              return params;
            }
          },
        },
      },
      series: [
        {
          type: 'bar',
          data: sourceData.views,
          label: {
            show: true,
            position: 'right',
          },
          itemStyle: {
            color: function (param: any) {
              return getRandomColor('watchRank', sourceData.views.length - param.dataIndex - 1);
            },
          },
        },
      ],
    };
    return option;
  }
};

const watchRankCharsOption = (sourceData: WatchRankData) => {
  watchRankChars.setOption(optionsWatchRank(sourceData));
};

const getViewsRank = () => {
  http.dotCensus.getViewsRank({ params: { studio_id: studioId } }).then((res) => {
    Object.keys(res.data.data).forEach((e) => {
      watchRankCharsDatas.node_title.push(res.data.data[e]['node_title']);
      watchRankCharsDatas.views.push(res.data.data[e]['views']);
    });

    // 观看排名
    const watchRankDom: HTMLElement = document.getElementById(watchRank.value) as HTMLElement;
    watchRankChars = echarts.init(watchRankDom);
    watchRankCharsOption(watchRankCharsDatas);
  });
};
getViewsRank();

// 访问来源
const accessSource = ref(`accessSource${Date.now() + Math.random()}`);

let accessSourceChars: echarts.ECharts;

const daccessSourceCharsData = ref<AccessSourceClass[]>([]);

const total_people = ref<number>();

const optionsAccessSource = (sourceData: AccessSourceClass[]) => {
  if (sourceData.length === 0) {
    const option = {
      title: {
        text: '{a| }',
        x: 'center',
        y: 'center',
        textStyle: {
          rich: {
            a: {
              color: '#000',
              fontSize: '16',
              height: 160,
              width: 172,
              backgroundColor: {
                image: emptyEcharts,
              },
            },
          },
        },
      },
    };
    return option;
  } else {
    const option = {
      tooltip: {
        trigger: 'item',
        formatter: function (params: AccessSourceClass) {
          return '&nbsp;&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;' + params.value + '人&nbsp;&nbsp;';
        },
      },
      legend: {
        top: '0%',
        right: 'right',
        fontSize: 12,
      },
      series: [
        {
          type: 'pie',
          center: ['40%', '50%'],
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            color: function (param: any) {
              return getRandomColor('accessSource', param.dataIndex);
            },
          },
          label: {
            position: 'inner',
            fontSize: 12,
            formatter: '{d}%',
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '13',
              fontWeight: 'bold',
            },
          },
          labelLine: {
            show: false,
          },
          data: sourceData,
        },
      ],
    };
    return option;
  }
};

const accessSourceCharsOption = (sourceData: AccessSourceClass[]) => {
  accessSourceChars.setOption(optionsAccessSource(sourceData));
};

const getAccessSource = () => {
  http.dotCensus.getAccessSource({ params: { studio_id: studioId } }).then((res) => {
    total_people.value = res.data.data.total_people;
    const resData = res.data.data.data ? res.data.data.data.map((e: AccessSource) => new AccessSourceClass(e)) : [];
    daccessSourceCharsData.value = resData.sort((a: AccessSourceClass, b: AccessSourceClass) => b.value - a.value);
    // 访问来源
    const accessSourceDom: HTMLElement = document.getElementById(accessSource.value) as HTMLElement;
    accessSourceChars = echarts.init(accessSourceDom);
    accessSourceCharsOption(daccessSourceCharsData.value);
  });
};
getAccessSource();

// 设备占比
const equipment = ref(`equipment${Date.now() + Math.random()}`);

let equipmentChars: echarts.ECharts;

const optionsEquipment = (sourceData: EquipmentClass[]) => {
  if (sourceData.length === 0) {
    const option = {
      title: {
        text: '{a| }',
        x: 'center',
        y: 'center',
        textStyle: {
          rich: {
            a: {
              color: '#000',
              fontSize: '16',
              height: 152,
              width: 163,
              backgroundColor: {
                image: emptyEcharts,
              },
            },
          },
        },
      },
    };
    return option;
  } else {
    const option = {
      tooltip: {
        trigger: 'item',
        formatter: function (params: EquipmentClass) {
          return '&nbsp;&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;' + params.value + '人&nbsp;&nbsp;';
        },
      },
      series: [
        {
          type: 'pie',
          radius: '70%',
          data: sourceData,
          itemStyle: {
            color: function (param: any) {
              return getRandomColor('accessSource', param.dataIndex);
            },
          },
          // label: {
          //   position: 'outside',
          //   fontSize: 12,
          //   formatter: '{d}%',
          // },
        },
      ],
    };
    return option;
  }
};

const equipmentCharsOption = (sourceData: EquipmentClass[]) => {
  equipmentChars.setOption(optionsEquipment(sourceData));
};

const getEquipmentRatio = () => {
  http.dotCensus.getEquipmentRatio({ params: { studio_id: studioId } }).then((res) => {
    const resData = res.data.data.map((e: Equipment) => new EquipmentClass(e)) || [];
    resData.sort((a: EquipmentClass, b: EquipmentClass) => b.value - a.value);

    // 设备占比
    const equipmentDom: HTMLElement = document.getElementById(equipment.value) as HTMLElement;
    equipmentChars = echarts.init(equipmentDom);
    equipmentCharsOption(resData);
  });
};
getEquipmentRatio();

// 地区排名
const regionRank = ref(`regionRank${Date.now() + Math.random()}`);

let regionRankChars: echarts.ECharts;

const regionRankCharsDatas = ref<RegionRankDataClass[]>([]);

const regionRankCharsOption = () => {
  regionRankChars.setOption({
    tooltip: {
      show: true,
      formatter: function (params: RegionRankDataClass) {
        if (params.value) {
          return '&nbsp;&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;' + params.value + '个&nbsp;&nbsp;';
        } else {
          return '&nbsp;&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;0个&nbsp;&nbsp;';
        }
      },
      feature: {
        saveAsImage: {}, // 保存为图片
      },
    },
    visualMap: {
      min: regionRankCharsDatas.value.length > 1 ? regionRankCharsDatas.value[regionRankCharsDatas.value.length - 1].value : 0,
      max: regionRankCharsDatas.value[0] ? regionRankCharsDatas.value[0].value : 0,
      calculable: true, //是否显示拖拽用的手柄
      itemWidth: 21,
      itemHeight: 130,
      right: '10%',
      bottom: '40',
      text: ['高', '低'],
      textStyle: {
        color: '#999999',
        fontSize: 13,
      },
      inRange: {
        color: ['#6394F9', '#00CCB0'],
      },
      outOfRange: {
        show: false,
      },
    },
    geo: {
      map: 'china',
      show: false,
      emphasis: {
        label: {
          show: false,
        },
      },
      itemStyle: {
        show: false,
      },
    },
    series: [
      {
        type: 'map',
        map: 'china',
        aspectScale: 0.85,
        showLegendSymbol: false, // 存在legend时显示
        zoom: 1,
        roam: false, //放大缩小
        label: {
          show: true,
          formatter: function (para: RegionRankDataClass) {
            if (para.value && para.value !== 0) {
              return '{name|' + para.name + '}';
            } else {
              return '';
            }
          },
          rich: {
            name: {
              fontSize: 11,
              color: '#ff4d4f',
              align: 'center',
              lineHeight: 60,
              show: true,
            },
          },
        },
        itemStyle: {
          areaColor: '#E9E9E9', //地图背景颜色
          borderColor: '#FFF',
          borderWidth: 1,
        },
        emphasis: {
          itemStyle: {
            //对应的鼠标悬浮效果
            areaColor: '#00ccb0',
            show: true,
          },
        },
        data: regionRankCharsDatas.value,
      },
    ],
  });
};

const mapColumns = reactive<Column[]>([
  {
    title: '排名',
    dataIndex: 'ranking',
    align: 'center',
    width: '16%',
  },
  {
    title: '省份',
    dataIndex: 'province',
    align: 'center',
    width: '16%',
  },
  {
    title: '观看量',
    dataIndex: 'value',
    align: 'center',
    width: '16%',
  },
  {
    title: '日同比',
    dataIndex: 'dayOnDay',
    align: 'center',
    slots: { customRender: 'dayOnDay' },
    width: '26%',
  },
  {
    title: '周同比',
    dataIndex: 'yearOnWeek',
    align: 'center',
    slots: { customRender: 'yearOnWeek' },
    width: '26%',
  },
]);

const mapSource = ref<MapSourceClass[]>([]);

const getRegionalRank = () => {
  http.dotCensus.getRegionalRank({ params: { studio_id: studioId } }).then((res) => {
    mapSource.value = res.data.data.map((e: MapSource) => new MapSourceClass(e));
    regionRankCharsDatas.value = res.data.data.map((e: MapSource) => new RegionRankDataClass(e));
    // 地区排名
    echarts.registerMap('china', china);
    const regionRankDom: HTMLElement = document.getElementById(regionRank.value) as HTMLElement;
    regionRankChars = echarts.init(regionRankDom);
    regionRankCharsOption();
  });
};
getRegionalRank();

const colorCode = (data: string) => {
  const tag = data.substring(0, 1);
  if (tag === '+') {
    return 'data_rise';
  } else {
    return 'data_ascent';
  }
};
const formatColorCode = (data: MapSourceClass, column: Column) => {
  if (column.dataIndex === 'dayOnDay') {
    return colorCode(data.dayOnDay);
  }
  if (column.dataIndex === 'yearOnWeek') {
    return colorCode(data.yearOnWeek);
  }
};

// 观看流水
const waterColumns = reactive<Column[]>([
  {
    title: '用户头像',
    dataIndex: 'avatar_url',
    align: 'center',
    slots: { customRender: 'avatar_url' },
  },
  {
    title: '用户昵称',
    dataIndex: 'user_name',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '用户ID',
    dataIndex: 'user_id',
    align: 'center',
  },
  {
    title: '地理位置',
    dataIndex: 'province',
    align: 'center',
  },
  {
    title: '来源访问',
    dataIndex: 'browser',
    align: 'center',
  },
  {
    title: '设备访问',
    dataIndex: 'device',
    align: 'center',
  },
]);
const waterSource = ref<WaterSource[]>([]);

const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 20, // 每页条数
  totalSize: 0, // 总页数
  options: ['10', '20', '30', '40', '50'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});

const getVisitRecord = useDebounce(() => {
  http.dotCensus
    .getVisitRecord({ params: { studio_id: studioId, page_num: pageConfig.pageSize, page: pageConfig.current } })
    .then((res) => {
      waterSource.value.push(...res.data.data.data);
      pageConfig.totalSize = res.data.data.total;
      pageConfig.current++;
    });
});
getVisitRecord();

const handleScroll = () => {
  //窗口滚要做的操作写这里
  let sh = document.querySelector('.ant-table-body')?.scrollHeight || document.body.scrollHeight; // 内容可视区域的高度加上溢出（滚动）的距离
  let st = document.querySelector('.ant-table-body')?.scrollTop || document.body.scrollTop; // 滚动条距离顶部的距离
  let ch = document.querySelector('.ant-table-body')?.clientHeight || document.body.clientHeight; // 内容可视区域的高度

  if (st + ch >= sh - 55) {
    //快到底时----加载
    if (pageConfig.totalSize && waterSource.value.length < pageConfig.totalSize) {
      getVisitRecord(); // 加载数据的方法
    }
  }
};
// 滚动事件
onMounted(() => {
  //监听页面滚动事件
  document.querySelector('.ant-table-body')?.addEventListener('scroll', handleScroll);
});

// eslint-disable-next-line @typescript-eslint/no-var-requires
const china = require('@/assets/json/china.json');

window.onresize = () => {
  statisticsChars.resize();
  watchRankChars.resize();
  accessSourceChars.resize();
  equipmentChars.resize();
  regionRankChars.resize();
};

const { proxy }: any = getCurrentInstance();
const token = getToken();
const corn = ref(1);
const messageTip = ref();
const exportList = useDebounce((type: number) => {
  // 1.观看总览；2.观看统计；3.访问来源；4.设备占比；5.区域排名；6.观看流水；7.观看排名
  const data = {
    studio_id: studioId,
    type: type,
    is_cron_download: corn.value,
  };
  https
    .export_dotting_data({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};
const watchExport = useDebounce((type: number) => {
  // 1.观看总览；2.观看统计；3.访问来源；4.设备占比；5.区域排名；6.观看流水；7.观看排名
  const data = {
    studio_id: studioId,
    type: type,
    is_cron_download: corn.value,
  };
  https
    .export_dotting_data({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(" 观看总览 "),
            _createVNode(_component_a_button, {
              type: "link",
              class: "mod_switch_btn mod_home_section_btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(exportList)(1)))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" }),
                _createTextVNode("导出 ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataOverview, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.key
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "left_one_wrap_item_left",
                    style: _normalizeStyle({ background: item.background })
                  }, [
                    _createVNode(_component_svg_icon, {
                      "icon-class": item.icon
                    }, null, 8, ["icon-class"])
                  ], 4),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h2", null, _toDisplayString(item.num), 1),
                    _createElementVNode("p", null, _toDisplayString(item.info), 1)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(" 观看排名 "),
            _createVNode(_component_a_button, {
              type: "link",
              class: "mod_switch_btn mod_home_section_btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(exportList)(7)))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" }),
                _createTextVNode(" 导出 ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "wrap_body_con",
              id: watchRank.value
            }, null, 8, _hoisted_11)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode(" 地区排名 "),
            _createVNode(_component_a_button, {
              type: "link",
              class: "mod_switch_btn mod_home_section_btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(exportList)(5)))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" }),
                _createTextVNode(" 导出 ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "map_wrap",
              id: regionRank.value
            }, null, 8, _hoisted_15),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("table", null, [
                _createElementVNode("thead", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapColumns, (column) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: column.title,
                      class: "table_header",
                      style: _normalizeStyle({ width: column.width })
                    }, [
                      _createElementVNode("div", null, _toDisplayString(column.title), 1)
                    ], 4))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                (mapSource.value.length > 0)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapSource.value, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.ranking,
                            class: "tr_body"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapColumns, (column) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: column.title,
                                class: "colstyle",
                                style: _normalizeStyle({ width: column.width })
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(formatColorCode(item, column))
                                }, [
                                  _createTextVNode(_toDisplayString(item[column.dataIndex]) + " ", 1),
                                  (column.dataIndex === 'dayOnDay' || column.dataIndex === 'yearOnWeek')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                        (formatColorCode(item, column) === 'data_rise')
                                          ? (_openBlock(), _createBlock(_unref(ArrowUpOutlined), { key: 0 }))
                                          : _createCommentVNode("", true),
                                        (formatColorCode(item, column) === 'data_ascent')
                                          ? (_openBlock(), _createBlock(_unref(ArrowDownOutlined), { key: 1 }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ], 4))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (mapSource.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_a_empty, {
                        class: "empty_wrap",
                        image: _unref(emptyDataSec),
                        description: "页面暂无数据信息~"
                      }, null, 8, ["image"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createTextVNode(" 观看统计 "),
            _createVNode(_component_a_button, {
              type: "link",
              class: "mod_switch_btn mod_home_section_btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(exportList)(2)))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" }),
                _createTextVNode("导出 ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", {
              class: "wrap_body_con",
              id: statistics.value
            }, null, 8, _hoisted_25)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createTextVNode(" 访问来源 "),
              _createVNode(_component_a_button, {
                type: "link",
                class: "mod_switch_btn mod_home_section_btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(exportList)(3)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" }),
                  _createTextVNode("导出 ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", {
                class: "wrap_body_con",
                id: accessSource.value
              }, null, 8, _hoisted_30),
              (total_people.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("p", _hoisted_33, _toDisplayString(total_people.value) + "人", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createTextVNode(" 设备占比 "),
              _createVNode(_component_a_button, {
                type: "link",
                class: "mod_switch_btn mod_home_section_btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(exportList)(4)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" }),
                  _createTextVNode("导出 ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", {
                class: "wrap_body_con",
                id: equipment.value
              }, null, 8, _hoisted_37)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createTextVNode(" 观看流水 "),
            _createVNode(_component_a_button, {
              type: "link",
              class: "mod_switch_btn mod_home_section_btn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(watchExport)(6)))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" }),
                _createTextVNode("导出 ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_unref(aTable), {
                columns: waterColumns,
                "data-source": waterSource.value,
                "row-key": "user_id",
                pagination: false,
                scroll: { y: 614 }
              }, {
                avatar_url: _withCtx(({ record }) => [
                  _createElementVNode("img", {
                    src: record.avatar_url,
                    class: "avatar"
                  }, null, 8, _hoisted_42)
                ]),
                _: 1
              }, 8, ["columns", "data-source"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})